export const environment = {
  production: false,
  baseUrl: 'https://api-simulation.bricksandagent.com',
  baseUrlVersion: '1.0',
  idp: {
    authority: 'https://identitysimulation.bricksandagent.com',
    clientId: '4789f8c8-43e5-4138-9730-f45d80ca9aea',
    scope:
      'openid offline_access custom.profile https://bricksandagent.com/agencymgmt.api https://bricksandagent.com/keyautomate.api',
  },
  iframe_integration: {
    origins: [
      'https://ptsimulation.bricksandagent.com',
      'https://demo.propertytree.com/',
    ],
    destinations: ['https://localhost:5200'],
  },
  agencyMgmt: {
    urlPrefix: '/agencymgmt/api',
  },
  keyAutomate: {
    urlPrefix: '/keyautomate/api',
  },
  // firebase: {
  //   apiKey: 'AIzaSyAVQ8HsfWe6nY_IMFtlZu3QSZ4yZqd-icY',
  //   authDomain: 'bricksandagentservices.firebaseapp.com',
  //   databaseURL: 'https://bricksandagentservices-maintenance.firebaseio.com',
  //   projectId: 'bricksandagentservices',
  //   storageBucket: 'bricksandagentservices.appspot.com',
  //   messagingSenderId: '165211137623',
  // },
  maintenanceApp: {
    baseUrl: 'https://pmsimulation.bricksandagent.com',
    isEnable: true,
  },
  invoiceProcessor: {
    baseUrl: 'https://invoiceautomatesimulation.bricksandagent.com',
    isEnable: true,
  },
  intercom: {
    appId: 'cfn7s491',
  },
  // googleTagManager: {
  //   id: 'GTM-MVRSP8J',
  // },
  // stripe: {
  //   publishableKey:
  //     'pk_test_51LLKCfLYi3mpFaKKrWg6btKZ1HsPoMNYQZnZ4gwE8PFueAZgbYwwQGz2HKCBwrstFD5tPiOCTYKYKKpo28cnJpHC003raPpER4',
  // },
};
